import _ from 'lodash';
import { createSelector } from 'reselect';

const layoutKey="layoutState";

export const getLayoutState = (state) => _.get(state, layoutKey);
export const getError = createSelector(getLayoutState, (state) => _.get(state, 'error'));
export const getErrorTitle = createSelector(getLayoutState, (state) => _.get(state, 'errorTitle'));
export const getLoadingCount = createSelector(getLayoutState, (state) => _.get(state, 'loadingCount'));
